import React from 'react';
import { AlertTriangleIcon, ClockIcon, ChevronRightIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
interface AttentionItem {
  id: string;
  type: 'dispute' | 'refund' | 'settlement';
  title: string;
  description: string;
  dueDate?: string;
  amount?: string;
  urgent?: boolean;
  link: string;
}
export function AttentionNeededWidget() {
  const navigate = useNavigate();
  const attentionItems: AttentionItem[] = [{
    id: '1',
    type: 'dispute',
    title: 'Dispute requires response',
    description: 'Dispute #DP-2024-0001',
    dueDate: 'Due in 2 hours',
    amount: 'RM 100.01',
    urgent: true,
    link: '/disputes/1'
  }, {
    id: '2',
    type: 'dispute',
    title: 'Dispute requires response',
    description: 'Dispute #DP-2024-0091',
    dueDate: 'Due in 5 hours',
    amount: 'RM 1,538.94',
    urgent: true,
    link: '/disputes/91'
  }];
  const getTypeColor = (type: string) => {
    switch (type) {
      case 'dispute':
        return 'text-red-600 bg-red-50';
      case 'refund':
        return 'text-orange-600 bg-orange-50';
      case 'settlement':
        return 'text-blue-600 bg-blue-50';
      default:
        return 'text-gray-600 bg-gray-50';
    }
  };
  return <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1619">
      <div className="flex items-center justify-between mb-3" data-id="element-1620">
        <h3 className="text-sm font-semibold text-gray-900 flex items-center" data-id="element-1621">
          <AlertTriangleIcon size={16} className="mr-2 text-orange-500" data-id="element-1622" />
          Attention needed
        </h3>
        <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-1623">
          {attentionItems.filter(item => item.urgent).length} urgent
        </span>
      </div>

      <div className="space-y-2" data-id="element-1624">
        {attentionItems.map(item => <button key={item.id} onClick={() => navigate(item.link)} className="w-full text-left p-2 rounded-md border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-all group" data-id="element-1625">
            <div className="flex items-start justify-between" data-id="element-1626">
              <div className="flex-1 min-w-0" data-id="element-1627">
                <div className="flex items-center gap-2 mb-1" data-id="element-1628">
                  <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium ${getTypeColor(item.type)}`} data-id="element-1629">
                    {item.type.charAt(0).toUpperCase() + item.type.slice(1)}
                  </span>
                  {item.urgent && <span className="inline-flex items-center text-xs text-red-600 font-medium" data-id="element-1630">
                      <ClockIcon size={10} className="mr-1" data-id="element-1631" />
                      Urgent
                    </span>}
                </div>
                <p className="text-xs text-gray-600 truncate" data-id="element-1632">
                  {item.description}
                </p>
                <div className="flex items-center gap-2 mt-1 text-xs text-gray-500" data-id="element-1633">
                  {item.dueDate && <span data-id="element-1634">{item.dueDate}</span>}
                  {item.amount && <span className="font-medium text-gray-900" data-id="element-1635">
                      {item.amount}
                    </span>}
                </div>
              </div>
              <ChevronRightIcon size={16} className="text-gray-400 group-hover:text-blue-600 transition-colors flex-shrink-0 ml-2" data-id="element-1636" />
            </div>
          </button>)}
      </div>

      <button onClick={() => navigate('/disputes')} className="w-full mt-3 text-xs text-blue-600 hover:text-blue-700 font-medium text-center" data-id="element-1637">
        View all items
      </button>
    </div>;
}